import React, { ReactNode, useMemo } from 'react';
import { ActionDropdown, DataCell } from 'vl-common/src/components/Table/TableDataView';

export function useTransformColumns<
  T extends {
    dataSourceKey?: string;
    display?: ReactNode;
    isSortable?: boolean;
    isAction?: boolean;
    actionItems?: any;
  }
>(columns: T[]) {
  const transformedColumns = useMemo(() => {
    return columns
      .filter((item) => item)
      .map((item) => ({
        ...item,
        dataIndex: item.dataSourceKey,
        key: item.dataSourceKey,
        title: item.display
      }))
      .map((item) => ({
        ...item,
        sorter: item.isSortable,
        render: (text, rowData) =>
          item.isAction ? (
            <ActionDropdown actionItems={item.actionItems} rowData={rowData} />
          ) : (
            <DataCell item={item} rowData={rowData} />
          )
      }));
  }, [columns]);
  return transformedColumns;
}

export default useTransformColumns;
